import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const PermissionEditModal = ({
  open,
  handleClose,
  editLoading,
  onEdit,
  initialValues,
}) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: { name: '', display: '' },
  });

  useEffect(() => {
    if (open) {
      reset({
        name: initialValues?.name ?? '',
        display: initialValues?.display ?? '',
      });
    }
  }, [open, initialValues, reset]);

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ویرایش دسترسی</DialogTitle>

      <DialogContent>
        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              autoFocus
              dir="ltr"
              label="عنوان سیستمی"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('name', { required: 'عنوان سیستمی الزامی است' })}
              error={isSubmitted ? !!errors.name : null}
              helperText={errors.name?.message}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              label="عنوان نمایشی"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('display', { required: 'عنوان نمایشی الزامی است' })}
              error={isSubmitted ? !!errors.display : null}
              helperText={isSubmitted ? errors.display?.message : null}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={editLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit(onEdit)}
          loading={editLoading}
          color="warning"
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionEditModal;
const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
